export default __webpack_public_path__ + "static/media/macbook-pro.29527f3f.glb";